import Pusher from 'pusher-js'

export function subscribePusherAsync (businessId, usersId) {
  const MOKA_PUSHER_KEY = process.env.MOKA_PUSHER_KEY
  const MOKA_PUSHER_APP_ID = process.env.MOKA_PUSHER_APP_ID
  const MOKA_PUSHER_SECRET = process.env.MOKA_PUSHER_SECRET
  const NODE_ENV = process.env.NODE_ENV

  let pusher = new Pusher(MOKA_PUSHER_KEY, {
    cluster: 'ap1',
    encrypted: true,
    appId: MOKA_PUSHER_APP_ID,
    secret: MOKA_PUSHER_SECRET
  })
  const isDevelopment = (NODE_ENV === 'development')
  if (isDevelopment) {
    Pusher.logToConsole = true
  }
  let channel = pusher.subscribe('moka-' + businessId + '-' + usersId)
  return channel
}



// WEBPACK FOOTER //
// ./app/utils/pusher.js